import {
  GET_LIST_MAU_IN_NHANVAY,
  GET_LIST_MAU_IN_NHANVAY_SUCCESS,
  GET_LIST_MAU_IN_NHANVAY_FAILURE,
  GET_NOI_DUNG_IN_NHANVAY,
  GET_NOI_DUNG_IN_NHANVAY_SUCCESS,
  GET_NOI_DUNG_IN_NHANVAY_FAILURE,
} from "../actions/InNhanVay/actionTypes";

const initialState = {
  inChoVayLoading: false,
  ListMauIn: [],
  NoiDungIn: "",
};

const getListMauInNhanVay = (state, action) => ({
  ...state,
  inChoVayLoading: true,
});

const getListMauInNhanVaySuccess = (state, action) => {
  return {
    ...state,
    inChoVayLoading: false,
    ListMauIn: action.payload,
  };
};

const getListMauInNhanVayFailed = (state, action) => ({
  ...state,
  inChoVayLoading: false,
  ListMauIn: [],
});

const getNoiDungInNhanVay = (state, action) => ({
  ...state,
  inChoVayLoading: true,
});

const getNoiDungInNhanVaySuccess = (state, action) => {
  return {
    ...state,
    inChoVayLoading: false,
    NoiDungIn: action.payload,
  };
};

const getNoiDungInNhanVayFailed = (state, action) => ({
  ...state,
  inChoVayLoading: false,
  NoiDungIn: "",
});

const inNhanVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_MAU_IN_NHANVAY:
      return getListMauInNhanVay(state, action);
    case GET_LIST_MAU_IN_NHANVAY_SUCCESS:
      return getListMauInNhanVaySuccess(state, action);
    case GET_LIST_MAU_IN_NHANVAY_FAILURE:
      return getListMauInNhanVayFailed(state, action);
    case GET_NOI_DUNG_IN_NHANVAY:
      return getNoiDungInNhanVay(state, action);
    case GET_NOI_DUNG_IN_NHANVAY_SUCCESS:
      return getNoiDungInNhanVaySuccess(state, action);
    case GET_NOI_DUNG_IN_NHANVAY_FAILURE:
      return getNoiDungInNhanVayFailed(state, action);
    default:
      return state;
  }
};

export default inNhanVayReducer;
